import { getSessionDuration } from 'application/session_duration'

export function pushEventToGTMDataLayer(data) {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({...data, session_duration: getSessionDuration() })
}

export function setSubmitFormLocalStorge(form) {
  const $gaForm = form
  const gaFormName = $gaForm.data('formName')
  const gaFormType = $gaForm.data('formType') || gaFormName
  const pageTitle = document.title

  localStorage.setItem('postponed_form_submit', JSON.stringify({
    form_name: gaFormName,
    form_type: gaFormType,
    form_page: pageTitle
  }))
}

export function getSubmitFormLocalStorge() {
  const saved = localStorage.getItem('postponed_form_submit')
  if (saved) {
    try {
      const data = JSON.parse(saved)

      const $fakeForm = $('<form>')
        .data('formName', data.form_name)
        .data('formType', data.form_type)

      document.title = data.form_page

      SOPHIA.formGA($fakeForm, 'form_submit')
    } catch (e) {
      console.error('Error restoring form data from localStorage:', e)
    } finally {
      localStorage.removeItem('delayed_form_submit')
    }
  }
}
